import { format, subDays } from "date-fns";
import { Calendar } from "primereact/calendar";
import React from "react";
import { useState } from "react";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";
import Axios from "../../api/Axios";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import storage from "../../Services/Storage";

const CollectionDataDownload = () => {
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const url = "CollectionDataDownload/GetAllCollectionData/GetAllCollectionData?";
    const auth = storage.getLocal("user");
    const handleGetCollectionData = async () => {
        setLoadingExcel(true);
        try{
            if (fromDate > toDate) {
                toast.warn("From Date should be equal to or less than To Date", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }
            const fDate = new Date(fromDate);
            const fromDateRange = format(fDate, "dd/MM/yyyy");
            const tDate = new Date(toDate);
            const toDateRange = format(tDate, "dd/MM/yyyy");
            let daycount = Math.round(
                (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24)
            );
            if(daycount>90){
                toast.warn("Date range should be within 90 days", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }
            const CollectionDataUrl = `${url}CompId=${auth.CompId}&FromDate=${fromDateRange}&ToDate=${toDateRange}&UserId=${auth.UserId}`;
            const res = await Axios.get(CollectionDataUrl);
            console.log(res,"CollectionDataUrl");
            if(res.data.Data==null){
                toast.warn("No data found", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
            else if(res.data.Data.length==0){
                toast.warn("No data found", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
            else{
                downloadExcel(res.data.Data,`Collection_Data_${GetDateFormat()}.xlsx`);
            }
        }catch(ex){
            toast.warn(ex.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }finally{
            setLoadingExcel(false);
        }
    };
    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">Collection Data Download</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    onClick={handleGetCollectionData}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Save As Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default CollectionDataDownload;